// Post, notification and chat ids. Pleroma's are text of one length;
// Mastodon's are numbers that grow a digit now and then ("10" after "9")
// and can be longer than a safe integer, so they are compared as text of
// equal length.

const numericId = /^\d+$/

export const isNumericId = (id) => numericId.test(id)

// the order of two ids: below 0, 0 or above 0
export const compareIds = (a, b) => {
  if (numericId.test(a) && numericId.test(b) && a.length !== b.length) {
    return a.length - b.length
  }
  return a < b ? -1 : a > b ? 1 : 0
}

// the id just before a numeric id, or null
export const idBefore = (id) =>
  numericId.test(id) ? (BigInt(id) - 1n).toString() : null
